export const siteDetails = {
  siteName: "Dataeden",
  siteUrl: "https://dataeden.se/",
  metadata: {
    title: "Dataeden – Webbutveckling, SEO & Digitala Lösningar i Göteborg",
    description:
      "Professionell webbutveckling och SEO-optimerade hemsidor i Göteborg. Vi hjälper företag att synas på Google och konvertera fler kunder med modern teknik och smarta digitala lösningar.",
  },
  language: "sv-SE",
  locale: "sv-SE",
  siteLogo: `${process.env.BASE_PATH || ""}/images/logo.png`, // Uppdatera vid behov
  googleAnalyticsId: "G-0VVXKGSRFN", // Lägg till om du har en GA-ID
}
